<template>
  <div id="orderinfo" class="orderinfo userbox" :class="{'type1': exchangeType == 1}" v-loading.fullscreen="loading">
    <div class="userTitle">
      {{$t('TradeCards')}}
    </div>
    <!--  -->
    <div class="exchangeOrder" v-if="isExchange">
      <div class="exchangeOrderAddress" v-if="addressList!=null">
        <to-address :title='title' :domVisible='dislogType.address' :list='addressItem' :isSet="isSet" @closeDialog="closeDialog" v-if="dislogType.address" />
        <div class="addressShow" :class="isAddShow?'on':''">
          <ul class="addressList">
            <!-- [item._id==list.AddressId?'on':isAdd==index?'on':''] -->
            <li v-for="(item,index) in addressList" :key='index' :class="isAdd==index?'on':''" @click="setOnlyAddress(index,item)">
              <div>
                <div class="addressName">{{item.City}} ({{item.UserName}}{{$i18n.locale==='zh'?"收":""}})</div>
                <div class="addressText line_txt2">{{item.Provice|setProvice}} {{item.AddressDetail}} {{item.ZipCode}}</div>
                <div class="addressPhone">{{item.Email}}</div>
                <div class="addressPhone">{{item.Mobile}}</div>
              </div>
              <span class="default" v-if="item.IsDefault">{{$t('Default')}}</span>
              <span class="setAddress" @click="setAddress('address',1,item)">{{$t('Edit')}}</span>
            </li>
          </ul>
        </div>
        <div class="setInfoBox space_between" :class="addressCount>0?'':'addressShow'">
          <div class='isShow' @click="IsShow" v-if="addressCount>3">{{isAddShow?$t('Hide'):$t('ViewAllAddresses')}}</div>
          <div class='isShow' v-else></div>
          <div class="setinfo" @click="setAddress('address',0)">{{$t('AddNewAddress')}}</div>
        </div>
      </div>
      <div>
        <div class="order_list order_list_title">
          <div class="order_list_products">{{$t('Cards')}}</div>
          <div class="order_list_detail">{{$t('ProductName')}}</div>
          <!-- <div class="order_list_price">卡号</div> -->
          <!-- <div class="order_list_total">交换截止日期</div> -->
         <!--  <div class="order_list_operate">操作</div> -->
        </div>

        <div class="order_list_border exchange_list_border" v-if="list!=null">
          <div class="order_list">
            <div class="order_list_products">
              <span class="order_img"><img :src="list.TitImg+'?imageView2/2/w/160'" /></span>
            </div>
            <div class="order_list_detail">
              <p class="line_txt3">{{list.Title}}</p>
              <span class="order_num">1</span>
              <span class="order_postage">{{$t('Shipping')}}：{{$t('PayonDelivery')}}</span>
            </div>
           <!--  <div class="order_list_price">
              <span>{{list.ExchangeCardCode}}</span>
            </div> -->
            <!-- <div class="order_list_total">
              <span>{{list.ClosingDate}}</span>
            </div> -->
            <!-- <div class="order_list_operate">
              <span>{{list.Status!=2?'未签名':'在库'}}</span>
            </div> -->
          </div>
        </div>
        <div class="subTotal">
          <el-button class='' type="" @click="IsExchange()">{{$t('Cancel')}}</el-button>
          <el-button class='subtn' type="primary" @click="payGo()">{{$t('ConfirmRedemption')}}</el-button>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="userRightSmallBox" v-if="!isExchange">
      <div class="exchangeBox">
        <router-link class="exchangeRecord" :to="{path:'/cypher'}">{{$t('RedemptionHistory')}}</router-link>
          <img class="exchangeLogo" src="../../../static/images/exchange.png" />
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item class="login_form_item" prop="exchangeCardCode">
            <el-input class="login_ipt" v-model="ruleForm.exchangeCardCode" :placeholder="$t('verify.RedemptionCode')" @input="setInput()">
            </el-input>
          </el-form-item>
          <!-- <el-form-item class="login_form_item" prop="password">
            <el-input class="login_ipt" v-model="ruleForm.password" placeholder="请输入你卡密" @input="setInput()">
            </el-input>
          </el-form-item> -->
          <el-button class="exchange_btn" :disabled='disabled' type="primary" @click="submitForm('ruleForm')">{{$t('RedeemNow')}}</el-button>
        </el-form>
      </div>
    </div>
    <!-- <nonull type='order' text="未找到订单" v-if="isNull" /> -->
  </div>
</template>
<script>
import { getInfo,Tip} from "@/api/public";
import Nonull from '@/components/nonull'
import ToAddress from '@/components/dialog/address'
export default {
  name: 'orderinfo',
  components: { Nonull, ToAddress },
  data() {
    return {
      exchangeType:0,
      isExchange: false,
      loading: false,
      userInfo: getInfo(),
      isNull: false,
      disabled: true,
      isAddShow: false,
      isAdd: 0,
      dislogType: this.$enumInfo.dislogType,
      pi: this.$enumInfo.addressPage.pageindex,
      ps: this.$enumInfo.addressPage.pagesize,
      list: '',
      addressItem: null,
      addressList: null,
      addressCount: 0,
      isSet: false,
      ruleForm: {
        exchangeCardCode: '',
        // password: ''
      },
      rules: {
        exchangeCardCode: [
          { required: true, message: this.$t('verify.RedemptionCode'), trigger: 'blur' },
        ],
        // password: [
        //   { required: true, message: '请输入你卡密', trigger: 'blur' },
        // ],
      },
    }
  },
  filters: {
    setProvice(val){
      // var regex = /(<([^>]+)>)/ig;
      if(val!=null){
        // val=val.replace(regex,'');
        val=val.replace(/\-/g,' ');
        //val=val.replace('&nbsp;','');
      }
      return val
    }
  },
  mounted() {
  },
  created() {
    // 接收路由参数 type
    this.exchangeType = this.$route.query.type || 0
   },
  methods: {
    /**
 * 获取可兑换商品列表
 * 
 * 根据用户会员ID和表单数据获取指定编码的可兑换商品列表。
 * 成功获取后，会加载用户地址信息并检查兑换状态。
 * 
 * @returns {void}
 */
    getExchangeCommodityList() {
      let that = this
      that.ruleForm.MemberId=that.userInfo._id
      let data=that.ruleForm
      that.$post(that.$interface.GetExchangeCommodityByCode,data).then(res=>{
        if(res.Result!=0){
          that.list=res.Data
          that.getAddress()
          that.IsExchange()
        }else{
          that.$message.error(res.Msg);
        }
      })
    },
    // 判断input是否有值
    setInput(val) {
      if ( this.ruleForm.exchangeCardCode != '') {
        this.ruleForm.exchangeCardCode= this.ruleForm.exchangeCardCode.toUpperCase()
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getExchangeCommodityList()
        }
      })
    },
    /**
 * 处理支付确认流程
 * 验证当前选中地址的邮箱信息，验证通过后弹出确认对话框
 * 用户确认后调用下单接口
 * 
 * 功能说明：
 * - 从地址列表中获取当前选中的地址详情
 * - 检查地址是否包含邮箱信息
 * - 若邮箱存在，显示确认兑换的弹窗
 * - 用户点击确认后执行 setOrder 方法创建订单
 * - 若邮箱不存在，显示警告提示用户补充邮箱
 */
    payGo() {
      let that = this
      const addressDetail = that.addressList[that.isAdd];
      if(addressDetail.Email){
        let html = `<div>${that.$t('verify.ConfirmCardRedemption')}</div>`
        this.$alert(html, that.$t('ConfirmRedemption'), {
          customClass: 'alert exchange',
          confirmButtonText: that.$t('Confirm'),
          dangerouslyUseHTMLString: true,
          lockScroll: false,
          callback: action => {
            that.setOrder()
          }
        });
      }else{
        Tip('warning',that.$t('alertEmail'))
      }
    },
    /**
 * 创建换卡订单
 * 
 * 根据选中的地址信息和换卡码创建新的换卡订单
 * 
 * 功能说明：
 * - 从地址列表中获取当前选中的地址详情
 * - 构建订单数据，包含会员ID、地址信息、联系方式、换卡码和密码
 * - 调用创建换卡订单接口
 * - 订单创建成功后跳转到加密页面，失败则显示错误提示
 * 
 * 依赖数据：
 * - addressList: 地址列表
 * - isAdd: 当前选中地址的索引
 * - userInfo: 用户信息
 * - ruleForm: 表单数据（包含换卡码和密码）
 */
    setOrder() {
      let that = this
      let addressDetail = that.addressList[that.isAdd];
      let data = {
          memberId: that.userInfo._id,
          addressId: addressDetail._id,
          userName: addressDetail.UserName,
          mobile: addressDetail.Mobile,
          provice: addressDetail.Provice,
          city: addressDetail.City,
          email:addressDetail.Email,
          addressDetail: addressDetail.AddressDetail,
          country: addressDetail.Country,
          zipCode: addressDetail.ZipCode,
          exchangeCardCode:that.ruleForm.exchangeCardCode,
          password: that.ruleForm.password
        }
      that.$post(that.$interface.CreateExchangeOrder,data).then(res=>{
        if(res.Result!=0){
          that.$router.push({ path: '/cypher' })
        }else{
          that.$message.error(res.Msg);
        }
      })
    },
    IsShow() {
      this.isAddShow = !this.isAddShow
    },
    IsExchange() {
      this.isExchange = !this.isExchange
    },
    setOnlyAddress(val) {
      this.isAdd = val;
      // if (this.ischeck) {
      //   this.upDataOrder()
      // }
    },
    /**
 * 获取用户的收货地址列表
 * 根据当前分页参数请求地址数据，并更新地址列表、总数和空状态
 * @returns {void}
 */
    getAddress() {
      let that = this;
      that.loading = true;
      let data = { MemberId: that.userInfo._id, PageIndex: that.pi, PageSize: that.ps }
      that.$get(that.$interface.SearchShippingAddresses, data).then(res => {
        if (res.Result != 0) {
          that.addressList = res.Data;
          that.addressCount = res.Count;
          that.isNull = res.Count > 0 ? false : true;
        } else {
          that.isNull = true;
        }
        that.loading = false;
      })
    },
    setAddress(val, type, obj) {
      if (type == 1) {
        this.title = this.$t('UpdateAddress')
        this.addressItem = JSON.parse(JSON.stringify(obj))
        //console.log(this.addressItem)
      } else {
        this.title = this.$t('AddNewAddress')
      }
      this.isSet = type > 0 ? false : true;
      this.dislogType[val] = true;
    },
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
      this.getAddress()
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/user.css";
@import "../../../static/css/pay.css";

/* exchangeType==1 时的主题色 */
.type1 /deep/ .exchange_btn {
  background-color: #F6B157;
  border-color: #F6B157;
}
.type1 /deep/ .exchange_btn.is-disabled {
  background-color: var(--button-primary-disabled);
  border-color: var(--button-primary-disabled-border);
}
</style>



// WEBPACK FOOTER //
// src/pages/user/exchange.vue